import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const emptyForm = (email = "") => ({ registrant_name: "", email, job_title: "", care_type: "", session_date: "", session_at: "" });

async function fetchWebinar() {
  try { return (await api.get("/oral-champion/webinar")).data; }
  catch { toast.message("Joining link will follow by email"); return {}; }
}

export function useChampionApply() {
  const nav = useNavigate();
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  const [form, setForm] = useState(emptyForm());
  const [loading, setLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(null);

  useEffect(() => {
    if (user) {
      setForm((f) => ({ ...f, email: user.email || "" }));
      api.get("/oral-champion/me").then((r) => setInfo(r.data)).catch(() => {});
    }
  }, [user]);

  const included = info ? !info.included_used : true;

  const startPayment = async (appId) => {
    toast.info("Additional champion — redirecting to secure payment…");
    const { data: co } = await api.post("/payments/checkout", { lookup_key: "oc_champion_extra", origin_url: window.location.origin, metadata: { champion_app_id: appId } });
    window.location.href = co.checkout_url;
  };

  const apply = async (e) => {
    e.preventDefault();
    if (!user) { toast.info("Please log in or start a trial to nominate your champion."); nav("/login"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/oral-champion/apply", form);
      setInfo((await api.get("/oral-champion/me")).data);
      if (!data.included) { await startPayment(data.id); return; }
      toast.success("Your included Oral Champion place is booked!");
      setConfirmed({ session: form.session_date, email: form.email, ...(await fetchWebinar()) });
      setForm(emptyForm(user.email || ""));
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return { nav, info, form, setForm, loading, confirmed, setConfirmed, included, apply };
}
